import { AlignType } from 'common/types/styleTypes'
import {
  FontProps,
  fontCss,
  lineHeightCss,
  mobileFontCss,
  mobileLineHeightCss,
  mobileTextAlignCss,
  textAlignCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'
import { WebsiteLogoPictureProps } from '../website-logo-picture'

interface WebsiteLogoTextUiStylesInterface extends FontProps {
  mobileImageSrc: string
  imageSrc: string
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  lineHeight?: number
  mobileLineHeight?: number
}

export const WebsiteLogoTextUi = styled.span<WebsiteLogoTextUiStylesInterface>`
  text-align: ${p => p.textAlign || 'center'};
  width: 100%;
  display: ${p => (p.imageSrc ? 'none' : 'block')};
  ${fontCss}
  ${lineHeightCss}
  ${textAlignCss}

  ${p =>
    p?.theme?.phone &&
    css`
      ${p.theme.phone} {
        display: ${p.mobileImageSrc ? 'none' : 'block'};
        ${mobileTextAlignCss}
        ${mobileFontCss}
        ${mobileLineHeightCss}
      }
    `}

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      display: ${p.mobileImageSrc ? 'none' : 'block'};
      ${mobileTextAlignCss}
      ${mobileFontCss}
      ${mobileLineHeightCss}
    `}
`

export const WebsiteLogoWrapperUi = styled.div`
  display: flex;
  align-items: center;
`

export const WebsiteLogoImageUi = styled.img<WebsiteLogoPictureProps>`
  display: ${p => (p.imageSrc ? 'block' : 'none')};
  object-fit: contain; // keep proportions
  width: auto;
  max-height: ${p => p.height ?? 50}px;

  ${p =>
    p?.theme?.phone &&
    css`
      ${p.theme.phone} {
        display: ${p.mobileImageSrc ? 'block' : 'none'};
        ${p.mobileHeight && `max-height: ${p.mobileHeight}px`};
      }
    `}

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      display: ${p.mobileImageSrc ? 'block' : 'none'};
      ${p.mobileHeight && `max-height: ${p.mobileHeight}px`};
    `}
`
